import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../api-response';

@Injectable({
  providedIn: 'root',
})
export class ApiInterfaceService {
  constructor(private http: HttpClient) {}

  private createHeaders(token: string): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
  }

  private applyCustomHeaders(
    baseHeaders: HttpHeaders | undefined,
    customHeaders?: Record<string, string>
  ): HttpHeaders | undefined {
    if (!customHeaders || Object.keys(customHeaders).length === 0) {
      return baseHeaders;
    }

    let headers = baseHeaders ?? new HttpHeaders();
    for (const [key, value] of Object.entries(customHeaders)) {
      headers = headers.set(key, value);
    }
    return headers;
  }

  get<T>(
    url: string,
    params?: any,
    customHeaders?: Record<string, string>
  ): Observable<ApiResponse<T>> {
    const headers = this.applyCustomHeaders(undefined, customHeaders);
    return this.http.get<ApiResponse<T>>(`${environment.baseUrl}${url}`, {
      params,
      headers,
    });
  }

  post<T>(
    url: string,
    data: any,
    isAuthorization?: boolean,
    accessToken?: any,
    customHeaders?: Record<string, string>
  ): Observable<ApiResponse<T>> {
    const authHeaders = isAuthorization
      ? this.createHeaders(accessToken)
      : undefined;
    const headers = this.applyCustomHeaders(authHeaders, customHeaders);
    return this.http.post<ApiResponse<T>>(
      `${environment.baseUrl}${url}`,
      data,
      headers ? { headers } : {}
    );
  }

  put<T>(
    url: string,
    data: any,
    customHeaders?: Record<string, string>
  ): Observable<ApiResponse<T>> {
    const headers = this.applyCustomHeaders(undefined, customHeaders);
    return this.http.put<ApiResponse<T>>(
      `${environment.baseUrl}${url}`,
      data,
      headers ? { headers } : {}
    );
  }

  delete<T>(
    url: string,
    customHeaders?: Record<string, string>
  ): Observable<ApiResponse<T>> {
    const headers = this.applyCustomHeaders(undefined, customHeaders);
    return this.http.delete<ApiResponse<T>>(
      `${environment.baseUrl}${url}`,
      headers ? { headers } : {}
    );
  }
}
